module.exports = __webpack_public_path__ + "img/erc20_usdt.9688e872.png";